enum HealthDeclarationStatus {
  ENTERED = 'ENTERED',
  USER_CREATED = 'USER_CREATED',
  INVITATION_SENT = 'INVITATION_SENT',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_FOR_SIGNING = 'WAITING_FOR_SIGNING',
  REJECTED = 'REJECTED',
  SIGNED = 'SIGNED',
  EXPIRED = 'EXPIRED',
  ARCHIVED = 'ARCHIVED',
  ERROR = 'ERROR',
  UNKNOWN_IN_SYSTEM = 'UNKNOWN_IN_SYSTEM',
  DOCUMENT_SENT_TO_SIGN_HOST = 'DOCUMENT_SENT_TO_SIGN_HOST',
}

export default HealthDeclarationStatus;
